module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('router-link', {
    staticClass: "pageLink saprator-bottom",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Home")])])]), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("Reports")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/DashboardModule"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink ",
    attrs: {
      "tag": "li",
      "to": "/Report"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Model Reports")])])]), _vm._v(" "), _c('li'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink saprator",
    attrs: {
      "to": "/DisplaySchedule",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-hourglass-start"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Schedule")])])]), _vm._v(" "), _c('li'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/DTStatus",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cubes"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("DT Status")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-384fc2c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 1003
// module chunks = 1